import React, { ReactNode, useEffect } from 'react';
import shuffle from 'lodash/shuffle';
import { BBCommonProps } from 'src/types/story';
import { BOX_TYPE } from '../components/common/BuildingBlocks/Box/constants';

/**
 * Hook to apply shuffle styles to the component.
 */
export function useShuffle(props: BBCommonProps & { children: ReactNode }, selector?: string) {
	const childrenAmount = React.Children.count(props.children);
	const shouldShuffle =
		!props.isEditableMode &&
		childrenAmount > 0 &&
		props.uiConfig.componentProps.other.boxType !== BOX_TYPE.FRAME &&
		props.uiConfig.componentProps.other.shuffle;
	const id = props.uiConfig.nodeProps?.id;

	useEffect(() => {
		if (!shouldShuffle || !id) {
			return () => {};
		}

		const style = document.createElement('style');
		const order = shuffle([...Array(childrenAmount).keys()]);

		style.setAttribute('data-title', 'storycards-shuffled-box');
		style.innerHTML = order
			.map(
				(shuffledIndex, index) =>
					`#${id} ${selector || ''} > :nth-child(${index + 1}) { order: ${shuffledIndex}; }`
			)
			.join('\n');

		document.head.appendChild(style);

		return () => {
			document.head.removeChild(style);
		};
	}, [shouldShuffle, childrenAmount, id, selector]);
}
